/* ==================================================
 *  Grid
 * ==================================================*/

(function () {

  'use strict';

  $(document).on('click', '[data-action="toggle-grid"]', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();

    var state = $('[data-lost-edit]').attr('data-lost-edit');

    $('[data-lost-edit]').attr('data-lost-edit', (state == 'on' ? 'off' : 'on'));
  });

})();
